<template>
  <div>
    <PCNavbar selectIndex="18"/>
    <MobileNavBar :currentActive="17" />
    <healthAndSafetyCategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import healthAndSafetyCategory from '@/components/service_health_and_safety_category-7/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    healthAndSafetyCategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>